import React from 'react';

// @ts-ignore: TS2459 — we know it's there at runtime
import { AttendanceChart } from '@PikaDoApp/pikado-web-dsm';


interface AttendanceChartContainerProps {
  selectedMonth: string;
  onMonthChange: (month: string) => void;
  monthOptions: Array<{label: string; value: string}>;
  studentsDailyRecord:Array<any>;
  totalAnswersCount:number;
  totalStudentsEngagedThisMonth:number
}

export const AttendanceChartContainer: React.FC<AttendanceChartContainerProps> = ({
  selectedMonth,
  onMonthChange,
  monthOptions,
  studentsDailyRecord,
  totalAnswersCount,
  totalStudentsEngagedThisMonth
}) => {



  return (
    <AttendanceChart
    totalAnswersCount={totalAnswersCount}
    totalStudentsEngagedThisMonth={totalStudentsEngagedThisMonth}
    studentsDailyRecord={studentsDailyRecord}
      monthOptions={monthOptions}
      selectedMonth={selectedMonth}
      onMonthChange={onMonthChange}
    />
  );
};
